import { render, staticRenderFns } from "./matchHDPOUMMOXOdds.vue?vue&type=template&id=0d3c584e&lang=pug&"
import script from "./matchHDPOUMMOXOdds.vue?vue&type=script&lang=js&"
export * from "./matchHDPOUMMOXOdds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports